module.exports = __webpack_public_path__ + "img/aicj-0.c253e7af.png";